import type { NativeContextRNProps } from "../props/NativeContextRNProps";

import { logGraphQLErrors } from "../logging/GraphQLErrorLogging";
import { logHttpError } from "../logging/NetworkLogging";

import { onError } from "@apollo/client/link/error";
import { print } from "graphql/index";

interface ApolloErrorLinkOptions {
  provider: string;
  nativeContext?: NativeContextRNProps;
}

const apolloErrorLink = ({ provider, nativeContext }: ApolloErrorLinkOptions) => {
  return onError(({ operation, graphQLErrors, networkError }) => {
    if (graphQLErrors) {
      logGraphQLErrors({
        provider,
        messages: graphQLErrors.map((error) => error.message),
        query: print(operation.query),
        operationName: operation.operationName,
        variables: JSON.stringify(operation.variables),
        nativeContext,
      });
    }
    if (networkError) {
      logHttpError(
        provider,
        operation.operationName,
        networkError.message,
        "statusCode" in networkError ? networkError.statusCode : 0,
        nativeContext,
      );
    }
  });
};

export default apolloErrorLink;
